<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from '@/plugins/i18n';
import { useSearchStore } from '@/components/Search/store/index.ts'
import SaiModal from '@/components/common/SaiModal/index.ce.vue';
import SearchFilters from '@/components/Search/SearchFilters/index.ce.vue';
import SearchBarAllFilters from './SearchBarAllFilters.ce.vue';
import { COLLECTIONS_SEARCH_TAB, STANDARDS_SEARCH_TAB } from '../../constants';

//props
const props = defineProps({
    display: { type: Boolean, default: false },
    forMobile: { type: Boolean, default: false }
})

//store
const searchStore = useSearchStore()

//translations
const i18nInstance: any = useI18n()
const { t } = i18nInstance

// emits
const emit = defineEmits(['closeModal', 'handleSearch', 'clearAll'])
const closeModal = () => {
  emit('closeModal')
}

const searchResultLoading = computed(() => {
  return searchStore[`${searchStore['activeTab']}.result.loading`] || false;
});

const handleDone = () => {
  let isCrossRefFilled = searchStore['activeTab'] == STANDARDS_SEARCH_TAB && searchStore[`${STANDARDS_SEARCH_TAB}.facetFilter.crossReference`]?.trim() !== '' ;
  let isNotesFilled = searchStore['activeTab'] == COLLECTIONS_SEARCH_TAB && searchStore[`${COLLECTIONS_SEARCH_TAB}.facetFilter.notes`]?.trim() !== '' ;
  if(isCrossRefFilled || isNotesFilled) {
    emit('handleSearch');
  } else {
    emit('closeModal')
  }
}
</script>

<template>
  <SaiModal
    :display="display"
    @closeModal="closeModal"
    className="all-filters-modal"
  >
    <template #title>
      {{t('filters')}}
      <div v-if="forMobile" class="clear-all-wrapper">
        <div class="clear-all" @click="() => emit('clearAll')">{{ t('clearAll') }}</div>
      </div>
    </template>
    <template #body>
      <div class="all-filters-body">
        <SearchBarAllFilters v-if="!searchStore['searchResultActive']"></SearchBarAllFilters>
        <SearchFilters v-else :forMobile="forMobile"></SearchFilters>
      </div>
      <div class="all-filter-result-count" v-if="forMobile && searchStore['searchResultActive']" >
        <template v-if="searchResultLoading">{{ t('loading') }}...</template>
        <template v-else>{{ t('showResults', [searchStore.getResultsRecordTotal(searchStore['activeTab']).toString()]) }}</template>
      </div>
      <div class="all-filters-footer">
        <button v-if="!forMobile || (forMobile && !searchStore['searchResultActive'])" class="btn btn-cancel" @click="closeModal">{{ t('cancel') }}</button>
        <button v-if="!forMobile || (forMobile && !searchStore['searchResultActive'])" class="btn btn-search" @click="emit('handleSearch')">{{ t('search') }}</button>
        <button v-if="forMobile && searchStore['searchResultActive']" class="btn btn-done" @click="handleDone">{{ t('done') }}</button>
      </div>
    </template>
  </SaiModal>
</template>